var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16602 11.152V4.16699H11.151V6.26095H6.25997V11.152H4.16602ZM4.16602 35.8336V28.8486H6.25997V33.7396H11.151V35.8336H4.16602ZM28.8476 35.8336V33.7396H33.7386V28.8486H35.8326V35.8336H28.8476ZM33.7386 11.152V6.26095H28.8476V4.16699H35.8326V11.152H33.7386ZM28.8593 28.8881H31.1809V31.2096H28.8593V28.8881ZM28.8593 24.245H31.1809V26.5665H28.8593V24.245ZM26.5484 26.5665H28.8593V28.8881H26.5484V26.5665ZM24.2269 28.8881H26.5484V31.2096H24.2269V28.8881ZM21.9053 26.5665H24.2269V28.8881H21.9053V26.5665ZM26.5484 21.9234H28.8593V24.245H26.5484V21.9234ZM24.2269 24.245H26.5484V26.5665H24.2269V24.245ZM21.9053 21.9234H24.2269V24.245H21.9053V21.9234ZM31.1809 8.79095V18.0772H21.9053V8.79095H31.1809ZM18.0762 21.9234V31.2096H8.78997V21.9234H18.0762ZM18.0762 8.79095V18.0772H8.78997V8.79095H18.0762ZM16.2921 29.4255V23.7075H10.5741V29.4255H16.2921ZM16.2921 16.293V10.5751H10.5741V16.293H16.2921ZM29.3967 16.293V10.5751H23.6895V16.293H29.3967Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckin);
export default __webpack_public_path__ + "static/media/checkin.6a54c4e12174ac719de3ed3f7db24576.svg";
export { ForwardRef as ReactComponent };